export class BackendError extends Error {
  public code?: string;

  constructor(message: string = '', code?: string) {
    super(message);
    this.name = 'BackendError';
    this.message = message;
    this.code = code;
  }
}

export const isBackendError = (error: Error): boolean => error instanceof BackendError;
